import React from 'react';
import { HelpCircle } from '@finect/tabular-icons/helpCircle';
import { Inner } from './partials';
export var OpenAction = function OpenAction(_ref) {
  var onAction = _ref.onAction;
  return React.createElement(Inner, {
    onClick: onAction
  }, React.createElement(HelpCircle, null), "\xBFNecesitas ayuda?");
};